var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcluirCompromisso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63673 20.5547C7.13806 20.5547 6.71206 20.3781 6.35873 20.0249C6.00556 19.6716 5.82898 19.2456 5.82898 18.7469V6.05467H4.82898V4.55467H9.32898V3.67017H15.329V4.55467H19.829V6.05467H18.829V18.7469C18.829 19.2521 18.654 19.6797 18.304 20.0297C17.954 20.3797 17.5264 20.5547 17.0212 20.5547H7.63673ZM17.329 6.05467H7.32898V18.7469C7.32898 18.8368 7.35781 18.9105 7.41548 18.9682C7.47315 19.0258 7.5469 19.0547 7.63673 19.0547H17.0212C17.0982 19.0547 17.1687 19.0226 17.2327 18.9584C17.2969 18.8944 17.329 18.8239 17.329 18.7469V6.05467ZM9.73298 17.0547H11.2327V8.05467H9.73298V17.0547ZM13.4252 17.0547H14.925V8.05467H13.4252V17.0547Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluirCompromisso);
export default __webpack_public_path__ + "static/media/Excluir_Compromisso.02675ab393db8b8f78ebe702490e4580.svg";
export { ForwardRef as ReactComponent };